export default "__VITE_ASSET__D4G8jKuc__"